/**
 * Day One Drop — førsteparts besøgsmåling til tema-A/B.
 * Sender anonyme hændelser til vores egen backend: sidevisning, produktvisning,
 * læg-i-kurv, kurv åbnet, checkout startet, sidehastighed og engagement.
 * Ingen navne, mails eller IP-adresser sendes.
 */
(function () {
  if (window.__dodTrackLoaded) return;
  window.__dodTrackLoaded = true;

  var ENDPOINT = "https://cdryatfajktldakuzzrj.supabase.co/functions/v1/theme-track";
  var COOKIE = "_dod_visit";
  var THEME_COOKIE = "_dod_theme";
  var SESSION_MINUTES = 30;

  var cfg = window.DOD_TRACK || {};

  function getCookie(name) {
    var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, days) {
    var d = new Date(Date.now() + days * 86400000);
    document.cookie =
      name + "=" + encodeURIComponent(value) + "; path=/; expires=" + d.toUTCString() + "; SameSite=Lax";
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return "v" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  /* Besøg: nyt id hvis der ikke er aktivitet i 30 minutter. */
  var raw = getCookie(COOKIE);
  var visitId = null;
  if (raw) {
    var parts = raw.split("|");
    if (parts.length === 2 && Date.now() - Number(parts[1]) < SESSION_MINUTES * 60000) visitId = parts[0];
  }
  if (!visitId) visitId = uuid();
  var touch = function () {
    setCookie(COOKIE, visitId + "|" + Date.now(), 1);
  };
  touch();

  /* Tema: "new" hvis vi kører på det nye tema-id, ellers "old". */
  var themeId = String(cfg.themeId || "");
  var bucket = getCookie(THEME_COOKIE);
  var theme = cfg.newThemeId && themeId && themeId === String(cfg.newThemeId)
    ? "new"
    : bucket === "new" && !cfg.newThemeId
      ? "new"
      : "old";

  function device() {
    var w = window.innerWidth || 0;
    if (w <= 749) return "mobile";
    if (w <= 1023) return "tablet";
    return "desktop";
  }

  function params() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (e) {
      return new URLSearchParams("");
    }
  }

  function referrerHost() {
    try {
      if (!document.referrer) return null;
      var h = new URL(document.referrer).hostname;
      return h === window.location.hostname ? null : h;
    } catch (e) {
      return null;
    }
  }

  function send(event, extra) {
    touch();
    var p = params();
    var payload = Object.assign(
      {
        visit_id: visitId,
        theme: theme,
        theme_id: themeId || null,
        event: event,
        device: device(),
        path: window.location.pathname,
        page_type: cfg.pageType || null,
        referrer_host: referrerHost(),
        utm_source: p.get("utm_source"),
        utm_medium: p.get("utm_medium"),
        utm_campaign: p.get("utm_campaign"),
      },
      extra || {}
    );
    var body = JSON.stringify(payload);
    try {
      if (navigator.sendBeacon) {
        navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "application/json" }));
        return;
      }
    } catch (e) {
      /* falder tilbage til fetch */
    }
    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body,
      keepalive: true,
    }).catch(function () {});
  }

  /* Sidevisning + produktvisning */
  send("page_view", {
    product_handle: cfg.productHandle || null,
    shopify_product_id: cfg.productId || null,
  });
  if (cfg.pageType === "product") {
    send("product_view", {
      product_handle: cfg.productHandle || null,
      shopify_product_id: cfg.productId || null,
      value_dkk: cfg.productPrice ? Number(cfg.productPrice) / 100 : null,
    });
  }

  /* Gem besøgs-id på kurven, så ordren senere kan kobles til besøget. */
  function tagCart() {
    if (window.__dodCartTagged) return;
    window.__dodCartTagged = true;
    fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { _dod_visit: visitId, _dod_theme: theme },
      }),
    }).catch(function () {
      window.__dodCartTagged = false;
    });
  }

  /* Læg-i-kurv: fang både formular-submit og AJAX-kald. */
  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (form && form.action && form.action.indexOf("/cart/add") !== -1) {
        send("add_to_cart", { product_handle: cfg.productHandle || null, shopify_product_id: cfg.productId || null });
        tagCart();
      }
    },
    true
  );

  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = "";
      try {
        url = typeof input === "string" ? input : (input && input.url) || "";
      } catch (e) {
        url = "";
      }
      if (url.indexOf("/cart/add") !== -1) {
        send("add_to_cart", { product_handle: cfg.productHandle || null, shopify_product_id: cfg.productId || null });
        setTimeout(tagCart, 400);
      }
      return origFetch.apply(this, arguments);
    };
  }

  /* Kurv åbnet */
  document.addEventListener(
    "click",
    function (e) {
      var el = e.target && e.target.closest ? e.target.closest("a,button") : null;
      if (!el) return;
      var href = el.getAttribute("href") || "";
      var id = el.id || "";
      if (href === "/cart" || id === "cart-icon-bubble" || el.closest("#cart-icon-bubble")) {
        send("cart_open");
      }
      if (el.name === "checkout" || href.indexOf("/checkout") === 0) {
        send("checkout_started");
        tagCart();
      }
    },
    true
  );

  /* Sidehastighed (LCP, CLS, INP-lignende, TTFB) */
  function vital(name, value) {
    if (value == null || !isFinite(value)) return;
    send("web_vital", { metric_name: name, metric_value: Math.round(value * 1000) / 1000 });
  }
  try {
    var nav = performance.getEntriesByType("navigation")[0];
    if (nav) vital("ttfb", nav.responseStart);
  } catch (e) {}
  try {
    var lcp = 0;
    new PerformanceObserver(function (list) {
      var entries = list.getEntries();
      lcp = entries[entries.length - 1].startTime;
    }).observe({ type: "largest-contentful-paint", buffered: true });

    var cls = 0;
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        if (!entry.hadRecentInput) cls += entry.value;
      });
    }).observe({ type: "layout-shift", buffered: true });

    var worstDelay = 0;
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (entry) {
        var d = entry.duration || entry.processingEnd - entry.startTime;
        if (d > worstDelay) worstDelay = d;
      });
    }).observe({ type: "event", buffered: true, durationThreshold: 40 });

    var start = Date.now();
    var flushed = false;
    var flush = function () {
      if (flushed) return;
      flushed = true;
      if (lcp) vital("lcp", lcp);
      vital("cls", cls);
      if (worstDelay) vital("inp", worstDelay);
      send("engagement", { metric_name: "engaged_ms", metric_value: Date.now() - start });
    };
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") flush();
    });
    window.addEventListener("pagehide", flush);
    setTimeout(flush, 20000);
  } catch (e) {
    /* browsere uden PerformanceObserver måler blot ikke hastighed */
  }
})();
